import React, { Component } from 'react';
import { Select } from 'antd';
import { connect } from 'react-redux';

import { SelectTab } from './styles';
import PropTypes from 'prop-types';

const Option = Select.Option;

export class MultiSelect extends Component {
  render() {
    return (
      <SelectTab
        stateModal={this.props.stateModal}
        filterModal={this.props.filterModal}
        filterSelect={this.props.filterSelect}
        mode={this.props.mode}
        defaultValue={this.props.defaultValue}
        optionFilterProp='children'
        showArrow={true}
        primary={this.props.mode === 'multiple' ? true : false}
        onChange={(value) => this.props.sorted(value)}
        value={this.props.value}
        data-test = 'select-tab'
      >
        {this.props.options.map((opt, inx) => (
          <Option
            key={opt.value}
            disabled={opt.key === 'select'}
            value={opt.key}
          >
            {opt.value}
          </Option>
        ))}
      </SelectTab>
    );
  }
}

MultiSelect.propTypes = {
  defaultValue: PropTypes.string.isRequired,
  mode: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  selectedVal: PropTypes.string,
  sorted: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default MultiSelect;
  